export const LocalStorageKey = {
    ROLE_TYPE: 'Role',
    AUTHORIZATION: 'Authorization',
    RE_AUTHORIZATION: 'ReAuthorization',
    LOGIN_STATE: 'EasyLoginState',
};
